import React, { useState } from 'react';
import { ContextMenu } from '@axiom/ui';
import type {
  Candidate,
  CandidateRedux,
  OpportunityCandidate,
  User,
} from '@axiom/validation';

import type { TalentInterviewAvailabilityModalProps } from '../TalentInterviewAvailabilityModal/TalentInterviewAvailabilityModal';
import { TalentInterviewAvailabilityModal } from '../TalentInterviewAvailabilityModal/TalentInterviewAvailabilityModal';
import { CandidateCalendarMenuContent } from '../CandidateCalendarMenuContent/CandidateCalendarMenuContent';
import { useInterviewAvailabilityCandidateData } from '../../hooks/useInterviewAvailabilityCandidateData';

export const CandidateCalendarMenu = ({
  candidate,
  user,
  icon,
  opportunityCandidate,
}: {
  user: User;
  candidate: CandidateRedux | Candidate;
  icon: React.JSX.Element;
  opportunityCandidate?: OpportunityCandidate;
}) => {
  const [
    showEditInterviewAvailabilityModal,
    setShowEditInterviewAvailabilityModal,
  ] = useState<TalentInterviewAvailabilityModalProps['defaultMode'] | null>(
    null
  );
  const { interviewCandidate } = useInterviewAvailabilityCandidateData({
    candidateRedux: candidate,
  });

  return (
    <>
      <ContextMenu
        name="INTERVIEW_AVAILABILITY_MENU"
        direction="left"
        anchor={icon}
      >
        <CandidateCalendarMenuContent
          opportunityCandidate={opportunityCandidate}
          user={user}
          onEditAvailability={setShowEditInterviewAvailabilityModal}
        />
      </ContextMenu>
      {showEditInterviewAvailabilityModal && interviewCandidate ? (
        <TalentInterviewAvailabilityModal
          candidate={interviewCandidate}
          user={user}
          onClose={() => {
            setShowEditInterviewAvailabilityModal(null);
          }}
          defaultMode={showEditInterviewAvailabilityModal}
          opportunityCandidateStatus={opportunityCandidate?.candidateStatus}
        />
      ) : null}
    </>
  );
};
